'use client';

import { Button, Modal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

import { VERIFICATION_TYPE } from '@/api';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useAuthStore } from '@/stores/AuthStore';

interface PaymentButtonProps {
  idx: string;
}

export const PaymentButton = ({ idx }: PaymentButtonProps) => {
  const myInfo = useAuthStore((state) => state.myInfo);
  const pathname = usePathname();
  const router = useCustomRouter();

  const [
    isRedirectVerificationConfirmModalOpened,
    setIsRedirectVerificationConfirmModalOpened,
  ] = useState(false);

  const handleClick = () => {
    //* 로그인 안되어 있을 경우
    if (!myInfo) {
      router.push(
        ROUTES.LOGIN.withSearchParams({
          searchParams: {
            redirect: pathname ?? '',
          },
        }),
      );

      return;
    }

    //* 휴대전화번호 없을 경우
    if (!myInfo.cellPhone) {
      setIsRedirectVerificationConfirmModalOpened(true);

      return;
    }

    router.push(
      ROUTES.PAYMENT_POINT_MARKET.pathname({
        idx,
      }),
    );
  };

  const disabledButton = myInfo === undefined;

  return (
    <>
      <Button
        className="flex-1"
        dimensions="H56"
        onClick={handleClick}
        disabled={disabledButton}
      >
        구매하기
      </Button>
      <RedirectVerificationConfirmModal
        opened={isRedirectVerificationConfirmModalOpened}
        onClose={() => setIsRedirectVerificationConfirmModalOpened(false)}
        onConfirm={() => {
          router.push(
            ROUTES.EASY_CERTIFICATION.withSearchParams({
              searchParams: {
                verification: VERIFICATION_TYPE.PROFILE_UPDATE,
                isNotUseCertificateCache: 'Y',
                redirect: pathname ?? '',
              },
            }),
          );
          setIsRedirectVerificationConfirmModalOpened(false);
        }}
      />
    </>
  );
};

interface RedirectVerificationConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RedirectVerificationConfirmModal = ({
  opened,
  onClose,
  onConfirm,
}: RedirectVerificationConfirmModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      header={
        <span className="w-full text-center mobile:typo-body1">
          모바일 쿠폰 발송을 위해
          <br />
          본인인증이 필요합니다
        </span>
      }
      description={
        <span className="inline-block w-full text-center">
          계속 하시겠습니까?
        </span>
      }
      buttonFooter={
        <div className="flex items-center gap-12">
          <Button
            theme="primary-fill"
            dimensions="H48"
            className="flex-1"
            onClick={onConfirm}
          >
            확인
          </Button>
          <Button
            theme="sub-line"
            dimensions="H48"
            className="flex-1"
            onClick={onClose}
          >
            취소
          </Button>
        </div>
      }
    />
  );
};
